import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { getBaseUrl, loadStorage, ConvertBytesToImage } from "../../Utils/Utils";

function Wishlist() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    const fetchWishlist = () => {
        const token = loadStorage("token");
        axios.get(`${getBaseUrl()}/wishlist`, { headers: { Authorization: `Bearer ${token}` } })
            .then(res => setItems(res.data))
            .catch(() => {})
            .finally(() => setLoading(false));
    };

    useEffect(() => { fetchWishlist(); }, []);

    const remove = async (productId) => {
        const token = loadStorage("token");
        await axios.delete(`${getBaseUrl()}/wishlist/${productId}`, { headers: { Authorization: `Bearer ${token}` } });
        setItems(prev => prev.filter(i => i.productId !== productId));
    };

    return (
        <div className="col-lg-8 col-md-8 col-12">
            <div className="ml-0 ml-md-4">
                <div className="card">
                    <div className="card-body">
                        {loading && <p>Loading...</p>}
                        {!loading && items.length === 0 && <p className="text-muted">Your wishlist is empty.</p>}
                        <div className="row">
                            {items.map(item => (
                                <div className="col-sm-6 col-lg-4 mb-3" key={item.id}>
                                    <div className="card h-100">
                                        {item.image && (
                                            <img
                                                src={ConvertBytesToImage(item.image)}
                                                alt={item.productName}
                                                className="card-img-top"
                                                style={{ height: 140, objectFit: 'contain', padding: 8 }}
                                            />
                                        )}
                                        <div className="card-body p-2">
                                            <p className="mb-1 small font-weight-bold">{item.productName}</p>
                                            <p className="mb-2 text-primary">₹{item.price}</p>
                                            <div className="d-flex gap-1">
                                                <button className="btn btn-sm btn-primary flex-fill" onClick={() => navigate(`/productDetail/${item.productId}`)}>View</button>
                                                <button className="btn btn-sm btn-outline-danger flex-fill" onClick={() => remove(item.productId)}>
                                                    <i className="ti-trash"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Wishlist;
